import { TRACKERS } from "@/constants/Trackers";
import { Goals } from "@/features/Patient/MedicalRecords/Goals/Goals";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/goals")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_GOALS);
  },
});

function RouteComponent() {
  return <Goals />;
}
